import React, { useState } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader'
import TableViewType from '../../../components/tableViewType/TableViewType'
import { Spacing } from '../../../components/table/Table'
import { ILink } from '../../../types'
import { PATHS } from '../../../routes/Routes'
import BulkConfigTable from './BulkConfigTable'
import BulkConfigHistoryFilters from './BulkConfigHistoryFilters'

const BulkConfigHistory = () => {
  const [viewType, setViewType] = useState<Spacing>(Spacing.Default)
  const navLinks: ILink[] = [
    {
      label: 'Batch Activity',
      link: PATHS.BATCH_ACTIVITY,
    },
    {
      label: 'Configurations',
      link: PATHS.VIEW_CONFIGURATIONS,
    },
    {
      label: 'Bulk Config History',
      link: PATHS.BULK_CONFIGURATIONS_HISTORY,
    },
  ]
  return (
    <div className='page-container'>
      <div className='page-content'>
        <PageHeader header='Bulk Config History' navLinks={navLinks}></PageHeader>
        <div className='table-filters'>
          <div className='filters-container'>
            <BulkConfigHistoryFilters />
          </div>
          <div className='table-view-type'>
            <TableViewType viewType={viewType} setViewType={setViewType} />
          </div>
        </div>
        <BulkConfigTable spacing={viewType} />
      </div>
    </div>
  )
}
export default BulkConfigHistory
